import { render, staticRenderFns } from "./CzPage.vue?vue&type=template&id=04ad8545&scoped=true&"
import script from "./CzPage.vue?vue&type=script&lang=ts&"
export * from "./CzPage.vue?vue&type=script&lang=ts&"
import style0 from "./CzPage.vue?vue&type=style&index=0&id=04ad8545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad8545",
  null
  
)

export default component.exports